module.exports = __webpack_public_path__ + "static/img/招聘官方公众号.c0d49a93.png";